import gql from "graphql-tag";
import { ShopFragments } from "@/graphql/Fragments";

export const CREATE_SHOP = gql`
  mutation createShopMutation($input: ShopCreateInput!) {
    createShop(input: $input) {
      ...shopFields
      ...shopLogoFields
    }
  }
  ${ShopFragments.shop}
  ${ShopFragments.shopLogo}
`;

export const UPDATE_SHOP = gql`
  mutation updateShopMutation($input: ShopUpdateInput!) {
    updateShop(input: $input) {
      ...shopFields
      ...shopLogoFields
    }
  }
  ${ShopFragments.shop}
  ${ShopFragments.shopLogo}
`;

export const DELETE_SHOP = gql`
  mutation deleteShopMutation($id: Int!) {
    deleteShop(id: $id) {
      id
    }
  }
`;

export const UPDATE_SHOP_PREFERENCES = gql`
  mutation updateShopPreferences($shopId: Int!, $prefs: ShopPrefsInput) {
    updateShopPreferences(shopId: $shopId, prefs: $prefs) {
      id
      ...shopPreferencesFields
    }
  }
  ${ShopFragments.shopPreferences}
`;

export const CLONE_SHOP = gql`
  mutation cloneShop($id: Int!, $newName: String!) {
    cloneShop(id: $id, newName: $newName) {
      id
    }
  }
`;
